module.exports = __webpack_public_path__ + "static/media/warning-icon.1d3fe0db.svg";